// extracted by mini-css-extract-plugin
export default {"PriceListSection":"styles_PriceListSection__j7btG","title":"styles_title__+aGUE","buyTicketButton":"styles_buyTicketButton__evaXS","priceBanner":"styles_priceBanner__hU-Cb"};